<template>
<div>
    <ModalCover @closeModal="$emit('closeTriggered')">
        <!-- MODAL BODY -->
        <div slot="modal-cover-body">
            <div class="delete-modal d-flex flex-column justify-content-start align-items-center">
                <!-- ERROR ALERT -->
                <div class="w-100" style="position: relative; top: 5px; margin-bottom: 15px;">
                    <AuthAlertCard v-if="show_alert" :alert_type="alert_type" :alert_msg="alert_msg"></AuthAlertCard>
                </div>

                <!-- DELETE CAN IMAGE -->
                <img v-lazy="localImg('DeleteCan.png')" alt>

                <!-- TITLE -->
                <div class="title color_text font-weight-bold text-center text-uppercase">REMOVE TEACHER FROM SCHOOL</div>

                <!-- DESCRIPTION -->
                <div class="description color_ash text-center">Are you sure you want to remove {{ teacher_data.name }}, from your school teachers list?</div>

                <!-- ACTION BUTTONS -->
                <div class="d-flex justify-content-center align-items-center nowrap">
                    <button class="btn btn-md btn-accent mr-3" @click="$emit('closeTriggered')">CANCEL</button>
                    <button class="btn btn-md btn-tonic-outline ml-3" @click="removeTeacher" ref="removeBtn">REMOVE</button>
                </div>
            </div>
        </div>
    </ModalCover>
</div>
</template>

<script>
import {
    mapActions
} from "vuex";
import ModalCover from "@/components/globalComps/ModalCover";
import {
    setTimeout
} from "timers";

export default {
    name: "RemoveTeacherFromSchool",

    props: {
        teacher_data: Object
    },

    components: {
        ModalCover,
        AuthAlertCard: () =>
            import( /* webpackChunkName: "AuthAlertCard" */ "@/components/globalComps/AuthComps/AuthAlertCard.vue")
    },

    data() {
        return {
            show_alert: false,
            alert_type: null, //SET TO EITHER SUCCESS OR ERROR
            alert_msg: null
        };
    },

    methods: {
        ...mapActions(["removeTeacherFromSchool"]),

        removeTeacher() {
            this.$refs.removeBtn.disabled = true;
            this.$refs.removeBtn.innerHTML =
                '<div class="icon-dotted-roller font-17 mr-2 animate"></div>Removing...';

            this.removeTeacherFromSchool(this.teacher_data.id)
                .then(response => {
                    if (response.code === 200) {
                        setTimeout(() => {
                            this.show_alert = false;

                            this.$refs.removeBtn.disabled = true;
                            this.$refs.removeBtn.innerHTML =
                                '<div class="icon-accept font-18 mr-2"></div>Removed!';
                        }, 1000);

                        setTimeout(() => {
                            let dialog_data = {
                                msg: "Teacher removed from school",
                                type: "success"
                            };
                            this.$emit("showAlertCard", dialog_data);
                            this.$emit("closeTriggered");
                        }, 3000);
                    }

                    // HANDLE NON 200 RESPONSE
                    else {
                        setTimeout(() => {
                            this.show_alert = true;
                            this.alert_type = "error";
                            this.alert_msg = response.message;

                            this.$refs.removeBtn.disabled = false;
                            this.$refs.removeBtn.innerHTML = "Remove";
                        }, 1000);

                        setTimeout(() => {
                            this.show_alert = false;
                        }, 5000);
                    }
                })
                .catch(err => console.log(err));
        }
    }
};
</script>

<style lang="scss">
.delete-modal {
    margin: 50px 70px;

    .title {
        margin-bottom: 20px;
        margin-top: 24px;
        font-size: 21px;
        line-height: 29px;

        @include breakpoint_max(sm) {
            font-size: 16px;
        }

        @include breakpoint_max(xs) {
            font-size: 15px;
        }
    }

    .description {
        font-size: 14px;
        line-height: 165%;
        margin-bottom: 30px;
        width: 85%;

        @include breakpoint_max(sm) {
            font-size: 12px;
            width: 105%;
        }

        @include breakpoint_max(xs) {
            width: 120%;
        }
    }

    .form-input {
        width: 80%;

        @include breakpoint_max(sm) {
            width: 105%;
        }

        @include breakpoint_max(xs) {
            width: 125%;
        }

        margin-bottom: 50px;

        input {
            background: $color_white;
            border: 1px solid $border_grey;
            box-sizing: border-box;

            &:focus {
                border: 1px solid $brand_accent;
            }
        }
    }

    .btn {
        @include breakpoint_max(sm) {
            font-size: 11px;
            padding: 10px 22px;
        }
    }
}
</style>
